import Vue from 'vue';
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
  setInteractionMode,
} from 'vee-validate';

import defaultLocale from '@/assets/locale/es.json';
import * as rules from 'vee-validate/dist/rules';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Object.keys(rules).forEach((rule) => {
  let ruleObj = {
    ...rules[rule], // copies rule configuration
    message: defaultLocale.messages[rule], // assign message
  };
  extend(rule, ruleObj);
});

localize('en', defaultLocale);

extend('url', {
  validate: (str) => {
    var pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ); // fragment locator
    return !!pattern.test(str);
  },
  message: 'No es una URL válida',
});

extend('money', {
  validate: (value) => {
    if (value == null || value == undefined) return false;

    let regex = /^\d*\.?\d*$/g;

    return value.toString().search(regex) !== -1;
  },
});

extend('ssn', {
  getMessage: () => 'El número de seguro social entrado no es valido.',
  validate: (value) => {
    if (value == null || value == undefined) return false;

    let regex = /^\d{3}-\d{2}-\d{4}$/g;

    return value.search(regex) !== -1;
  },
});

extend('hasSymbolsNumbersLowerCPassword', (value) => {
  let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z])/g;
  if (value.search(regex) !== -1) return true;
  return 'La contraseña debe incluir mínimo una letra mayúscula, un símbolo y número';
});

extend('hasCorrectSizeCPassword', (value) => {
  let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{6,16}$/g;
  if (value.search(regex) !== -1) return true;
  return 'Este campo no debe ser menor de 6 caracteres ni mayor a 16 caracteres.';
});

extend('isEqualToCPassword', (value, args) => {
  if (args.length > 0) {
    if (value === args[0]) return true;
  }
  return 'Esta contraseña debe ser igual a la entrada en el campo de nueva contraseña.';
});

extend('mustBeDifferentThanCPassword', (value, args) => {
  if (args.length > 0) {
    if (value !== args[0]) return true;
  }
  return 'La contraseña nueva no puede ser igual a la anterior.';
});

extend('differentFromZero', (value) => {
  if (!isNaN(value) && value != 0) return true;
  return 'Favor de añadir un valor diferente de cero';
});

extend('greaterThanZero', (value) => {
  if (!isNaN(value) && value > 0) return true;
  return 'Favor de añadir un valor mayor de cero';
});

extend('notEmptyObject', (value, args) => {
  if (args.length > 0) {
    const key = args[0];
    if (value[key] > 0 && value[key] !== '') return true;
  }
  return 'El campo es requerido';
});

extend('studentSie', (value) => {
  const str = value.toString();
  if (!isNaN(value) && value && str.length === 8) return true;
  return 'El número de SIE no es correcto.';
});

extend('tapRequestNumber', {
  getMessage: () => 'El número de consulta no es válido.',
  validate: (value) => {
    if (!value || value == undefined) return false;
    let regex = /^([aA-zZ]{3})-([\d]{4})-([\d]{2})-([\d]{6})/g;

    return value.search(regex) !== -1;
  },
});

extend('numeric', (value) => {
  if (!value || isNaN(Number(value))) {
    return 'El campo debe ser un número.';
  }
  return true;
});

extend('completePersonalSsn', (value) => {
  if (value != null) {
    let ssn = value
      .toString()
      .replace(/\D/g, '')
      .toString();
    if (ssn.length < 9 && ssn.length != 0) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
});

setInteractionMode('eager');
